import { normalizePreloader } from "@/lib/preloaders";

const CSS = `
@keyframes ms-bag-drop { 0% { transform: translateY(-14px); opacity: 0; } 35% { opacity: 1; } 70% { transform: translateY(6px); } 100% { transform: translateY(4px); opacity: 1; } }
@keyframes ms-cart-roll { 0% { transform: translateX(-18px); } 100% { transform: translateX(18px); } }
@keyframes ms-wheel { to { transform: rotate(360deg); } }
@keyframes ms-scan { 0% { transform: translateY(-18px); opacity: 0; } 15% { opacity: 1; } 85% { opacity: 1; } 100% { transform: translateY(18px); opacity: 0; } }
@keyframes ms-lid { 0%, 100% { transform: translateY(0); } 45% { transform: translateY(-8px) rotate(-6deg); } }
@keyframes ms-shutter { 0%, 20% { transform: translateY(0); } 70%, 100% { transform: translateY(-22px); } }
.ms-preloader-stage { color: #1c1917; }
.ms-bag-drop { animation: ms-bag-drop 1.1s ease-in-out infinite; }
.ms-cart { animation: ms-cart-roll 1.1s ease-in-out infinite alternate; }
.ms-wheel { transform-origin: center; animation: ms-wheel 0.7s linear infinite; }
.ms-scan { animation: ms-scan 1.15s ease-in-out infinite; }
.ms-lid { transform-origin: 20px 16px; animation: ms-lid 1.2s ease-in-out infinite; }
.ms-shutter { animation: ms-shutter 1.3s ease-in-out infinite; }
`;

function Stage({ children, preview }) {
  return (
    <div className={`ms-preloader-stage relative mx-auto ${preview ? "h-16 w-16" : "h-20 w-20"}`} aria-hidden>
      {children}
    </div>
  );
}

function Bag() {
  return (
    <Stage>
      <svg viewBox="0 0 64 64" className="w-full h-full" fill="none">
        <path d="M22 26h20l-2 24H24L22 26z" stroke="currentColor" strokeWidth="2.2" />
        <path d="M26 26c0-6 3-10 6-10s6 4 6 10" stroke="currentColor" strokeWidth="2.2" />
        <rect className="ms-bag-drop" x="29" y="18" width="6" height="6" rx="1" fill="#15803d" />
      </svg>
    </Stage>
  );
}

function Cart() {
  return (
    <Stage>
      <svg viewBox="0 0 64 64" className="w-full h-full ms-cart" fill="none">
        <path d="M14 20h6l4 18h20l4-12H24" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
        <circle className="ms-wheel" cx="28" cy="44" r="3" stroke="currentColor" strokeWidth="2" />
        <circle className="ms-wheel" cx="42" cy="44" r="3" stroke="currentColor" strokeWidth="2" />
      </svg>
    </Stage>
  );
}

function Barcode() {
  return (
    <Stage>
      <svg viewBox="0 0 64 64" className="w-full h-full" fill="none">
        <rect x="16" y="18" width="3" height="28" fill="currentColor" />
        <rect x="22" y="18" width="1.5" height="28" fill="currentColor" />
        <rect x="26" y="18" width="4" height="28" fill="currentColor" />
        <rect x="33" y="18" width="2" height="28" fill="currentColor" />
        <rect x="38" y="18" width="1.5" height="28" fill="currentColor" />
        <rect x="42" y="18" width="4" height="28" fill="currentColor" />
        <rect className="ms-scan" x="14" y="30" width="36" height="2" fill="#15803d" />
      </svg>
    </Stage>
  );
}

function Gift() {
  return (
    <Stage>
      <svg viewBox="0 0 64 64" className="w-full h-full" fill="none">
        <path className="ms-lid" d="M18 26h28v6H18z" fill="#15803d" />
        <path className="ms-lid" d="M30 18c-4 0-7 3-7 6h8v-6zm4 0v6h8c0-3-3-6-7-6z" stroke="currentColor" strokeWidth="2" />
        <rect x="16" y="32" width="32" height="16" stroke="currentColor" strokeWidth="2.2" />
        <path d="M32 32v16" stroke="currentColor" strokeWidth="2" />
      </svg>
    </Stage>
  );
}

function Shutter() {
  return (
    <Stage>
      <svg viewBox="0 0 64 64" className="w-full h-full" fill="none">
        <rect x="14" y="16" width="36" height="34" rx="2" stroke="currentColor" strokeWidth="2" />
        {[0, 1, 2, 3].map((i) => (
          <rect key={i} className="ms-shutter" x="18" y={22 + i * 6} width="28" height="3" rx="1" fill="currentColor" style={{ animationDelay: `${i * 0.12}s` }} />
        ))}
      </svg>
    </Stage>
  );
}

const ART = { bag: Bag, cart: Cart, barcode: Barcode, gift: Gift, shutter: Shutter };

export default function SitePreloader({ id, testId, preview = false, compact = false }) {
  const chosen = normalizePreloader(id);
  const Art = ART[chosen];
  const frame = preview
    ? "h-24 flex items-center justify-center"
    : compact
      ? "min-h-[40vh] flex items-center justify-center"
      : "min-h-[100dvh] flex items-center justify-center";
  const quiet = preview || chosen === "none";
  return (
    <div className={`${frame} text-stone-500 ${chosen === "none" ? "bg-white" : "bg-stone-50"}`} data-testid={testId || undefined} role={quiet ? undefined : "status"} aria-label={quiet ? undefined : "Loading store"}>
      <style>{CSS}</style>
      {chosen === "none" ? (preview ? <span className="text-xs tracking-wide uppercase text-stone-400">None</span> : null) : Art ? <Art /> : null}
    </div>
  );
}
